import CalendarWCellSlot from "./CalendarWCellSlot";
import moment from "moment";

export default ({ day, time, events, onClickEvent, onClickSlot }) => {
  return (
    <div
      className={`calendar-calendar-horas-ind-agenda-ind ${day && day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? "calendar-week-day-today" : ""}`}
      style={{
        backgroundColor:
          day && (day.format("d") === "0" || day.format("d") === "6")
            ? "#e2f5ff"
            : "white",
      }}
    >
      <CalendarWCellSlot
        day={day}
        time={time}
        minute="00"
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
      />
      <CalendarWCellSlot
        day={day}
        time={time}
        minute="15"
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
      />
      <CalendarWCellSlot
        day={day}
        time={time}
        minute="30"
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
      />
      <CalendarWCellSlot
        day={day}
        time={time}
        minute="45"
        events={events}
        onClickEvent={onClickEvent}
        onClickSlot={onClickSlot}
      />
    </div>
  );
};
